import axios from '../utils/requset';

const apply = {
    // 获取小区订单统计
    getCommunityOrder(params) {
        return axios.get("/service-admin/driver/getCommunityOrder/total", { params });
    },

    // 获取小区商户数量
    getCommunityBusiness(params) {
        return axios.get("/service-admin/driver/getCommunityBusiness/total", { params });
    },

    // 获取小区订单信息
    getOrder(params) {
        return axios.get("/service-admin/driver/getOrder/byType", { params });
    },

    // 获取小区文章
    getArticle(params) {
        return axios.get("/service-admin/driver/getArticle/byCommunity", { params });
    },

    // 获取小区信息
    getHome(params) {
        return axios.get("/service-admin/community/driver/home/", { params });
    },

    // 获取车辆和车位统计
    getCar(params) {
        return axios.get("/service-admin/community/driver/home/car", { params });
    },

    // 获取物业缴费统计
    getEst(params) {
        return axios.get("/service-admin/community/driver/home/est", { params });
    },

    // 获取小区房屋申请统计
    getHouse(params) {
        return axios.get("/service-admin/community/driver/home/house", { params });
    },

    // 获取用户房屋申请列表
    getHousePage(params) {
        return axios.get("/service-admin/community/driver/home/housePage", { params });
    },

    // 获取人数和房屋统计
    getPeople(params) {
        return axios.get("/service-admin/community/driver/home/people", { params });
    },

    // 获取年龄分布
    getAge(params) {
        return axios.get("/service-admin/community/driver/home/age", { params });
    },

    // 获取物业报修统计
    getProperty(params) {
        return axios.get("/service-admin/community/driver/home/property", { params });
    },

    //获取物业报修记录
    getPropertyPage(params) {
        return axios.get("/service-admin/community/driver/home/propertyPage", { params });
    },

    // 获取住户类型统计
    getCategory(params) {
        return axios.get("/service-admin/community/driver/home/category", { params });
    },

    // 获取性别分布
    getGender(params) {
        return axios.get("/service-admin/community/driver/home/gender", { params });
    },
    // 获取天气信息
    getWeatherInfo(params) {
        return axios.get("/service-business-base/map/weatherInfo", { params });
    },
    
    
     

}

export default apply;